import React from 'react';
import {useTranslation} from 'react-i18next';
import {toPriceStr} from '@/components/utils/converter';
import globalStore from '@/services/global.state';
import withdrawAmountConfig from '../config/withdraw-amount.config';
import useWithdrawStore from '../withdraw.store';

export interface WithdrawInputProps {
  value?: number | null;
  onChange?: (amount: number) => void;
}

const WithdrawInput: React.FC<WithdrawInputProps> = ({onChange}) => {
  const {i18n} = useTranslation();
  const selected = useWithdrawStore(s => s.selectedAmount);
  const setSelectedAmount = useWithdrawStore(state => state.setSelectedAmount);
  const handleSelect = (amount: number) => {
    setSelectedAmount(amount);
    onChange?.(amount);
  };

  const baseStyle: React.CSSProperties = {
    borderRadius: 4,
    border: '1px solid rgba(255, 255, 255, 0.50)',
    background: 'linear-gradient(180deg, #F2F4F9 0%, #F3F5FB 100%)',
    boxShadow: '0px 2px 0px 0px #C3C8DC',
  };

  const activeStyle: React.CSSProperties = {
    borderRadius: 4,
    border: '1px solid rgba(255, 255, 255, 0.10)',
    background: 'var(--1)',
    boxShadow: 'none',
    color: '#FFF',
  };

  return (
    <div className="bg-[#fff] rounded-[0.5rem] p-3 flex flex-col gap-2 mt-4">
      <div className="text-t1 text-sm font-medium">
        {i18n.t('withdraw-page.label.withdrawAmount')}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {withdrawAmountConfig.options.map(amount => {
          const isActive = selected === amount;
          return (
            <button
              type="button"
              key={amount}
              onClick={() => handleSelect(amount)}
              className={
                'flex items-center justify-center h-10 p-2 gap-1 w-full font-bold text-[14px] tracking-[-0.28px] font-inter'
              }
              style={isActive ? activeStyle : baseStyle}>
              {toPriceStr(amount, {
                thousands: true,
                spacing: false,
                currency: globalStore.currency,
                showCurrency: true,
                fixed: 0,
              })}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(WithdrawInput);
